<template>
  <teleport to="body">
    <div class="toast-wrap" role="region" aria-label="Notifications">
      <TransitionGroup name="toast" tag="ul" class="toast-list">
        <li v-for="t in items" :key="t.id" class="toast" :class="`toast--${t.kind}`">
          <div class="toast-body">
            <div class="toast-icon" aria-hidden="true">{{ icon(t.kind) }}</div>
            <div class="toast-content">
              <strong v-if="t.title" class="toast-title">{{ t.title }}</strong>
              <p class="toast-msg" data-cy="toast-msg">{{ t.message }}</p>
              <button v-if="t.action" class="toast-action" @click="t.action.onClick()">
                {{ t.action.label }}
              </button>
            </div>
            <button
              v-if="t.dismissible"
              class="toast-close"
              @click="dismiss(t.id)"
              aria-label="Close"
            >
              ×
            </button>
          </div>
        </li>
      </TransitionGroup>
    </div>
  </teleport>
</template>
<script setup lang="ts">
import { useToast } from '../composables/useToast'
const { items, dismiss } = useToast()
function icon(kind: string) {
  switch (kind) {
    case 'success':
      return '✓'
    case 'error':
      return '⨯'
    case 'warning':
      return '!'
    default:
      return 'ℹ'
  }
}
</script>
<style scoped>
.toast-wrap {
  position: fixed;
  left: 50%;
  bottom: 16px;
  transform: translateX(-50%);
  z-index: 9999;
  pointer-events: none;
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 0 12px;
}
.toast-list {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  max-width: min(92vw, 560px);
  width: max-content;
}
.toast {
  pointer-events: auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 8px 16px;
  border-radius: 25px;
  border: 1px solid var(--border-color);
  background: var(--text-color);
  color: var(--background-color);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
  max-width: min(92vw, 560px);
  width: max-content;
}
.toast-body {
  display: inline-flex;
  align-items: center;
  gap: 12px;
}
.toast-icon {
  line-height: 1;
  font-weight: 700;
}
.toast-content {
  min-width: 0;
}
.toast-title {
  display: block;
  margin: 0 0 2px;
}
.toast-msg {
  margin: 0;
  word-wrap: break-word;
  white-space: pre-wrap;
}
.toast-action {
  margin: 0;
  border: 0;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.12);
  padding: 6px 10px;
  color: inherit;
}
.toast-close {
  border: 0;
  background: transparent;
  color: inherit;
  font-size: 18px;
  line-height: 1;
}
.toast--success .toast-icon {
  color: #22c55e;
}
.toast--error .toast-icon {
  color: #ef4444;
}
.toast--warning .toast-icon {
  color: #f59e0b;
}
.toast--info .toast-icon {
  color: #60a5fa;
}
.toast-enter-from,
.toast-leave-to {
  opacity: 0;
  transform: translateY(6px);
}
.toast-enter-active,
.toast-leave-active {
  transition:
    opacity 0.18s,
    transform 0.18s;
}
@media (max-width: 480px) {
  .toast-wrap {
    bottom: 12px;
    padding: 0 8px;
  }
  .toast {
    padding: 8px 14px;
  }
}
</style>
